import { ReactElement } from 'react';
import { ColorFatLabel, ColorOnlyIcon, ColorThinLabel } from './styles';

export type TagType = 'normal' | 'thin' | 'iconOnly';

export interface TagI {
  type?: TagType;
  color?: string;
  label?: string;
  dataTestId?: string;
  icon?: ReactElement;
}

const Tag = ({ type, color, label, icon, dataTestId }: TagI): ReactElement => {
  switch (type) {
    case 'iconOnly':
      return (
        <ColorOnlyIcon data-testid={dataTestId} color={color}>
          {icon}
        </ColorOnlyIcon>
      );
    case 'thin':
      return (
        <ColorThinLabel data-testid={dataTestId} color={color}>
          {icon}
          <span>{label}</span>
        </ColorThinLabel>
      );
    case 'normal':
    default:
      return (
        <ColorFatLabel data-testid={dataTestId} color={color}>
          {icon}
          <span>{label}</span>
        </ColorFatLabel>
      );
  }
};

export default Tag;
